import * as Amplitude from '@amplitude/node';

// Hardcode
const AMPLITUDE_API_KEY = '0344e3b29ce409e4aca1123934802fe6';
const AMPLITUDE_HTTP_URL = 'https://api2.amplitude.com/2/httpapi';
const client = Amplitude.init(AMPLITUDE_API_KEY);

var amplitude = {
  trackEvent: trackEvent,
  hashEmail: hashEmail,
  sendBeacon: sendBeaconEvent,
  getIncomingDeviceId: getIncomingDeviceId
};

async function hashEmail(email) {
  if (!email || typeof window === 'undefined' || !window.crypto?.subtle) {
    return undefined;
  }
  const encoded = new TextEncoder().encode(email.toLowerCase().trim());
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', encoded);
  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

// Marketplace hands off its Amplitude device_id via `?amp_device_id=` on the
// booking redirect. It arrives nested inside `return_to`, so we match it
// anywhere in the query string rather than parsing a top-level param.
function getIncomingDeviceId() {
  try {
    if (typeof location === 'undefined') return null;
    const match = location.search.match(/amp_device_id=([^&?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  } catch (e) {
    return null;
  }
}

function getDeviceId() {
  try {
    // Prefer (and persist) the marketplace device_id when present, so every
    // event in the booking funnel — here and on marketplace — shares one
    // device and stitches to a single user in Amplitude.
    const incoming = getIncomingDeviceId();
    if (incoming) {
      localStorage.setItem('amp_device_id', incoming);
      return incoming;
    }
    let id = localStorage.getItem('amp_device_id');
    if (!id) {
      id = `web-${Date.now()}-${Math.random()
        .toString(36)
        .slice(2)}`;
      localStorage.setItem('amp_device_id', id);
    }
    return id;
  } catch (e) {
    return undefined;
  }
}

async function trackEvent(event_type, event_properties = {}, email = null) {
  const user_id = email ? await hashEmail(email) : undefined;
  // Return the logEvent promise so callers can await delivery before
  // navigating away (the upload is async and won't survive a hard redirect).
  return client.logEvent({
    event_type: event_type,
    user_id: user_id || undefined,
    device_id: getDeviceId(),
    event_properties: event_properties
  });
}

// Envío síncrono, fire-and-forget, directo al HTTP API de Amplitude.
// A diferencia del SDK (que sube por XHR y se cancela al navegar), el
// beacon lo mantiene vivo el navegador aunque la página se vaya a otro
// sistema. Recibe el user_id YA calculado para no tener ningún await de
// por medio: se encola de inmediato.
function sendBeaconEvent(event_type, event_properties = {}, user_id) {
  const payload = JSON.stringify({
    api_key: AMPLITUDE_API_KEY,
    events: [
      {
        event_type: event_type,
        user_id: user_id || undefined,
        device_id: getDeviceId(),
        event_properties: event_properties,
        time: Date.now()
      }
    ]
  });

  // 1) sendBeacon: sobrevive al unload de la página.
  if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
    const blob = new Blob([payload], { type: 'application/json' });
    if (navigator.sendBeacon(AMPLITUDE_HTTP_URL, blob)) {
      return true;
    }
  }

  // 2) Fallback: fetch con keepalive (también sobrevive a la navegación).
  try {
    fetch(AMPLITUDE_HTTP_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true
    });
  } catch (e) {
    // no-op
  }
  return false;
}

export default amplitude;
